import React from "react";
// import "antd/dist/antd.css";
import { useFullScreenHandle } from "react-full-screen";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { Provider, Subscribe } from "unstated";
import "./App.css";
import allStores from "./containers";
import About from "./fragments/About";
import Contact from "./fragments/Contact";
import FoortBarMobile from "./fragments/FoortBarMobile";
import FooterBar from "./fragments/FooterBar";
import Home from "./fragments/Home";
import NavBar from "./fragments/NavBar";
import NavBarMobile from "./fragments/NavBarMobile";
import { useResponsive } from "./hooks/responsive";

function App() {
  const [
    isTabletOrMobileDevice,
    isTabletOrMobile,
    isBigScreen,
    isDesktopOrLaptop,
    isPortrait,
    isRetina,
    isTablet,
  ] = useResponsive();
  const handle = useFullScreenHandle();
  return (
    <div id="home">
      <div id="line-background"></div>
      <Router>
        <div>{isTabletOrMobileDevice ? <NavBarMobile /> : <NavBar />}</div>
        <div>
          <Routes>
            <Route exact path="/" element={<Home />}></Route>
            <Route exact path="/about" element={<About />}></Route>
            <Route exact path="/home" element={<Home />}></Route>
            <Route exact path="/contact" element={<Contact />}></Route>
            <Route exact path="/:id" element={<Home />}></Route>
          </Routes>
        </div>
        <div>{isTabletOrMobileDevice ? <FoortBarMobile /> : <FooterBar />}</div>
      </Router>
    </div>
  );
}

function app() {
  const masterStore = allStores[0];
  console.disableYellowBox = true;
  return (
    <Provider inject={allStores}>
      <Subscribe to={[masterStore]}>
        {(masterStore) => (
          <>
            <App />
          </>
        )}
      </Subscribe>
    </Provider>
  );
}

export default app;
